import React, { FC } from 'react'
import {
  TextareaProps as ChTextareaProps,
  Textarea as ChTextarea,
} from '@chakra-ui/react'

export type TextareaProps = { dataCy?: string } & ChTextareaProps

export const Textarea: FC<TextareaProps> = ({
  value: possiblyNullValue,
  dataCy,
  ...props
}) => {
  const value = possiblyNullValue === null ? '' : possiblyNullValue
  return <ChTextarea {...props} data-cy={dataCy} value={value} />
}
